<h1>{{(data$ | async)?.description}}</h1>

{{reportDescription$ | async}}

<!-- {{getQueryParms()}} -->

<div class="alert alert-warning">Report results are limited to only those contracts that
  you have access to
</div>

<span
  *ngIf="(reportParameters$ | async)?.indexOf('ProductList') >= 0 || (reportParameters$ | async)?.indexOf('MoleculeList') >= 0 || (reportParameters$ | async)?.indexOf('TerritoryList') >= 0">Please
  note that you cannot select more than 5 options in each of the Product, Molecule and Territory drop down
  lists</span>

<ng-form #parmForm="ngForm" class="form__cont" novalidate>
  <!-- <div class="form-container"
    [matTooltip]="(libraryLimit$ | async) ? 'A maximum for '+ reportLimit + ' libraries can be selected': ''"
    *ngIf="(reportParameters$ | async)?.indexOf('LibraryFolder') >= 0 && (libraries$ | async)?.length >= 0">
    <app-multiselect-wrapper label="Libraries" name="Libraries" #Libraries="ngModel" [(ngModel)]="library"
      [folders]="libraries$" [objectStore]="objectStore$ | async" [allowSearchFilter]="true" [allowCheckAll]="true"
      [singleSelection]="false" [limitSelections]="libraryLimit$ | async" [required]="true">
    </app-multiselect-wrapper>

  </div> -->

  <div class="form-container" *ngIf="(reportParameters$ | async)?.indexOf('LibraryFolder') >= 0"
    [matTooltip]="(libraryLimit$ | async) ? 'A maximum for '+ reportLimit + ' libraries can be selected': ''">
    <app-multiselect-wrapper label="Libraries" name="Libraries" #Libraries="ngModel" [(ngModel)]="library"
      [choiceListName]="'LibraryFolder'" [gerritServiceName]="'Folder'" [objectStore]="objectStore$ | async"
      [allowSearchFilter]="true" [allowCheckAll]="true" [singleSelection]="false"
      [limitSelections]="libraryLimit$ | async" [required]="true">
    </app-multiselect-wrapper>

  </div>

  <div class="form-container" *ngIf="(reportParameters$ | async)?.indexOf('TerritoryFolder') >= 0">
    <app-multiselect-wrapper label="Territories" name="Territories" #Territories="ngModel" [(ngModel)]="territory"
      [choiceListName]="'TerritoryFolder'" [gerritServiceName]="'Folder'" [objectStore]="objectStore$ | async"
      [allowSearchFilter]="true" [allowCheckAll]="true" [singleSelection]="false" [limitSelections]="5"
      [required]="false">
    </app-multiselect-wrapper>

  </div>

  <!-- <div class="form-container"
    *ngIf="(reportParameters$ | async)?.indexOf('CategoryFolder') >= 0 && (categories$ | async)?.length >= 0">
    <app-multiselect-wrapper label="Categories" name="Categories" #Libraries="ngModel" [(ngModel)]="category"
      [folders]="categories$" [objectStore]="objectStore$ | async" [allowSearchFilter]="true" [allowCheckAll]="true"
      [singleSelection]="true" [limitSelections]="5">
    </app-multiselect-wrapper>

  </div> -->
  <div class="form-container" *ngIf="(reportParameters$ | async)?.indexOf('CategoryFolder') >= 0">
    <app-multiselect-wrapper label="Categories" name="Territories" #Categories="ngModel" [(ngModel)]="category"
      [choiceListName]="'CategoryFolder'" [gerritServiceName]="'Folder'" [objectStore]="objectStore$ | async"
      [allowSearchFilter]="true" [allowCheckAll]="true" [singleSelection]="false" [limitSelections]="5"
      [required]="false">
    </app-multiselect-wrapper>

  </div>

  <div class="form-container" *ngIf="(reportParameters$ | async)?.indexOf('DateFrom') >= 0 ">
    <mat-form-field appearance="outline">
      <mat-label>Date From</mat-label>
      <input #DateFrom="ngModel" name="DateFrom" [(ngModel)]="dateFrom" matInput [matDatepicker]="pickerDateFrom"
        placeholder=" Choose a date yyyy/mm/dd" [required]="true" [max]="dateTo" />
      <mat-datepicker-toggle matSuffix [for]="pickerDateFrom">
        <mat-icon matDatepickerToggleIcon><img src="assets/images/icon-calender.svg" /></mat-icon>
      </mat-datepicker-toggle>
      <mat-datepicker #pickerDateFrom></mat-datepicker>
      <mat-error><span *ngIf="DateFrom?.errors?.required">Field is required in format yyyy/mm/dd </span>
        <span *ngIf="DateFrom?.errors?.matDatepickerMax">From date must be before end date </span>
      </mat-error>
    </mat-form-field>
  </div>

  <div class=" form-container" *ngIf="(reportParameters$ | async)?.indexOf('DateTo') >= 0 ">
    <mat-form-field appearance="outline">
      <mat-label>Date To</mat-label>
      <input #DateTo="ngModel" name="DateTo" [(ngModel)]="dateTo" [min]="dateFrom" matInput
        [matDatepicker]="pickerDateTo" placeholder=" Choose a date yyyy/mm/dd" [required]="true" />
      <mat-datepicker-toggle matSuffix [for]="pickerDateTo">
        <mat-icon matDatepickerToggleIcon><img src="assets/images/icon-calender.svg" /></mat-icon>
      </mat-datepicker-toggle>
      <mat-datepicker #pickerDateTo></mat-datepicker>
      <mat-error><span *ngIf="DateTo?.errors?.required">Field is required in format yyyy/mm/dd </span>
        <span *ngIf="DateTo?.errors?.matDatepickerMin">End date must be after from date </span>
      </mat-error>
    </mat-form-field>
  </div>

  <div class="form-container" *ngIf="(reportParameters$ | async)?.indexOf('NotificationTypeList') >= 0 ">
    <app-multiselect-wrapper label="Notification Type" name="NotificationList" #NotificationList="ngModel"
      [(ngModel)]="notificationList" [choiceListName]="'AlertTemplates'" [objectStore]="objectStore$ | async"
      [allowSearchFilter]="true" [allowCheckAll]="true" [singleSelection]="false" [limitSelections]="5"
      [required]="true">
    </app-multiselect-wrapper>

  </div>

  <div class="form-container" *ngIf="(reportParameters$ | async)?.indexOf('DeletedReason') >= 0 ">
    <app-multiselect-wrapper label="DeletedReason" name="deletedReason" #DeletedReason="ngModel"
      [(ngModel)]="deletedReason" [choiceListName]="'ContractDeletedReason'" [objectStore]="objectStore$ | async"
      [allowSearchFilter]="true" [allowCheckAll]="true" [singleSelection]="false" [required]="false">
    </app-multiselect-wrapper>

  </div>
  <!--
  <div class="form-container" *ngIf="(reportParameters$ | async)?.indexOf('DeletedReason') >= 0 ">
    <app-multiselect-wrapper label="Deleted Reason" name="deletedReason" #DeletedReason="ngModel"
      [(ngModel)]="deletedReason" [choiceListName]="'ContractDeletedReason'" [objectStore]="objectStore$ | async"
      [allowSearchFilter]="true" [allowCheckAll]="true"  [singleSelection]="true">
    </app-multiselect-wrapper>

  </div> -->

  <div class="form-container" *ngIf="(reportParameters$ | async)?.indexOf('ProductList') >= 0 ">
    <app-multiselect-wrapper label="Products" name="productList" #ProductList="ngModel" [(ngModel)]="productList"
      [choiceListName]="'allProducts'" [gerritServiceName]="'allProducts'" [objectStore]="objectStore$ | async"
      [allowSearchFilter]="true" [allowCheckAll]="true" [singleSelection]="false" [limitSelections]="5"
      [required]="false">
    </app-multiselect-wrapper>

  </div>

  <div class="form-container" *ngIf="(reportParameters$ | async)?.indexOf('MoleculeList') >= 0 ">
    <app-multiselect-wrapper label="Molecules" name="MoleculeList" #MoleculeList="ngModel" [(ngModel)]="moleculeList"
      [choiceListName]="'allMolecules'" [gerritServiceName]="'allMolecules'" [objectStore]="objectStore$ | async"
      [allowSearchFilter]="true" [allowCheckAll]="true" [singleSelection]="false" [limitSelections]="5">
    </app-multiselect-wrapper>

  </div>

  <div class="form-container" *ngIf="(reportParameters$ | async)?.indexOf('TerritoryList') >= 0 ">
    <app-multiselect-wrapper label="Territories" name="TerritoryList" #TerritoryList="ngModel"
      [(ngModel)]="territoryList" [choiceListName]="'allTerritories'" [gerritServiceName]="'allTerritories'"
      [objectStore]="objectStore$ | async" [allowSearchFilter]="true" [allowCheckAll]="true" [singleSelection]="false"
      [limitSelections]="5">
    </app-multiselect-wrapper>

  </div>

  <div class="form-container" *ngIf="(reportParameters$ | async)?.indexOf('UPI') >= 0 ">
    <mat-form-field appearance="outline">
      <mat-label>UPI</mat-label>
      <input #ContractUPI="ngModel" name="uPI" matInput [(ngModel)]="uPI" />
    </mat-form-field>
  </div>

  <div class="form-container" *ngIf="(reportParameters$ | async)?.indexOf('ContractIdentifier') >= 0 ">
    <mat-form-field appearance="outline" matTooltip="Enter multiple contract Ids with a ',' between each">
      <mat-label>Contract Identifer</mat-label>
      <input #ContractUPI="ngModel" name="ContractIdentifier" matInput [(ngModel)]="ContractIdentifier"
        [required]="true" />
    </mat-form-field>
  </div>

  <div class="form-container" *ngIf="(reportParameters$ | async)?.indexOf('UserIdAudit') >= 0 ">
    <app-multiselect-wrapper label="Users" name="Users" #usersList="ngModel" [(ngModel)]="userList"
      [choiceListName]="'allAuditUsers'" [gerritServiceName]="''" [objectStore]="objectStore$ | async"
      [allowSearchFilter]="true" [allowCheckAll]="true" [singleSelection]="false" [limitSelections]="5"
      [required]="true">
    </app-multiselect-wrapper>
  </div>


  <div class="form-container" *ngIf="(reportParameters$ | async)?.indexOf('UserId') >= 0 ">
    <app-multiselect-wrapper label="Users" name="Users" #usersList="ngModel" [(ngModel)]="userList"
      [choiceListName]="'allUsers'" [gerritServiceName]="''" [objectStore]="objectStore$ | async"
      [allowSearchFilter]="true" [allowCheckAll]="true" [singleSelection]="false" [limitSelections]="5"
      [required]="true">
    </app-multiselect-wrapper>
  </div>



  <div class="form-container" *ngIf="(reportParameters$ | async)?.indexOf('BusinessOwner') >= 0 ">
    <mat-form-field appearance="outline" *ngIf="null | asyncBusinessOwnerAll | async as ownerAll">
      <mat-label>Business Owner</mat-label>
      <mat-select #ContractBusinessOwner="ngModel" name="ContractBusinessOwner" [(ngModel)]="businessOwner" required>
        <ngx-mat-select-search name="boSearch" [(ngModel)]="boSearch" [placeholderLabel]="'Search...'"
          [noEntriesFoundLabel]="'notfound'"></ngx-mat-select-search>

        <mat-option value="" disabled selected>Please select</mat-option>
        <mat-option *ngFor="let ownr of ownerAll | stringFilterBy : boSearch : 'fullname'" [value]="ownr.id">
          {{ownr.fullname}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>



  <div class=" form-container" *ngIf="(reportParameters$ | async)?.indexOf('TypeOfAccess') >= 0 ">
    <mat-form-field appearance="outline">
      <mat-label>Type of Access</mat-label>
      <mat-select #TypeOfAccess="ngModel" name="TypeOfAccess" [(ngModel)]="typeOfAccess" required>

        <mat-option value="" disabled selected>Please select</mat-option>
        <mat-option value="ALL">All</mat-option>
        <mat-option value="READ">Reader</mat-option>
        <mat-option value="INITIATOR">Initiator</mat-option>
      </mat-select>
    </mat-form-field>
  </div>


  <div class="form-container" *ngIf="(reportParameters$ | async)?.indexOf('UserEnabled') >= 0 ">
    <mat-form-field appearance="outline">
      <mat-label>User Enabled</mat-label>
      <mat-select #TypeOfAccess="ngModel" name="userEnabled" [(ngModel)]="userEnabled" required>

        <mat-option value="" disabled selected>Please select</mat-option>
        <mat-option value="ALL">All</mat-option>
        <mat-option value="true">Enabled Only</mat-option>
        <mat-option value="false">Disabled only</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <!-- {{parmForm.valid | json}} -->
  <ng-container *ngIf="(data$ | async)?.description as title">
    <div *ngIf="(data$ | async).path as path" class="DownloadButton">
      <a [disabled]="parmForm.invalid ||  noParameters() ||  downloading" *ngIf="(objectStore$ | async) as objectStore"
        mat-raised-button color="primary"
        (click)="getReport(parmForm.invalid ||  noParameters() ||  downloading,path,objectStore,title + '.xlsx')">
        Download Report</a>
    </div>
  </ng-container>




</ng-form>


<div *ngIf="this.downloading || (loading$ | async)" class="spinner">
  <mat-spinner></mat-spinner>
</div>

<div class="alert alert-warning" *ngIf="downloadError">Error downloading report</div>
